// Russian pluralisation: picks the word form by number.
// forms = [1 form, 2-4 form, 5-0 form] — e.g. [задача, задачи, задач].
export function pluralRu(n: number, forms: readonly [string, string, string]): string {
  const abs = Math.abs(n);
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1];
  return forms[2];
}

export const TASK_FORMS = ["задача", "задачи", "задач"] as const;
export const SUBTASK_FORMS = ["подзадача", "подзадачи", "подзадач"] as const;
export const CHANGE_FORMS = ["изменение", "изменения", "изменений"] as const;

/** «5 задач», «1 задача» — the number plus the right form of the word. */
export function taskCount(n: number): string {
  return `${n} ${pluralRu(n, TASK_FORMS)}`;
}

/** «5 подзадач», «1 подзадача». */
export function subtaskCount(n: number): string {
  return `${n} ${pluralRu(n, SUBTASK_FORMS)}`;
}

/** «5 изменений», «1 изменение». */
export function changeCount(n: number): string {
  return `${n} ${pluralRu(n, CHANGE_FORMS)}`;
}
